<template>
  <div class="col">
    <div id="main" class="col-main">
      <div class="row no-gutters row-main justify-content-center">
        <div class="col-12 col-lg-10 bg-white">
          <div class="row no-gutters justify-content-center">
            <div class="col-12 col-lg-9">
              <h2 class="section-title">
                Adults Ealing Trailfinders Cricket Club, Selection
              </h2>
            </div>

            <div class="col-12 col-lg-9">
              <!-- Text -->
              <p class="h5">
                0 This is where we will publish our teams on a weekly basis.
                Please come back soon to see if you’ve been selected for the
                week’s fixtures. <br />All players must provide match
                availability by confirming on Spond app. The teams are usually
                announced by wednesday evenings on this page. Please contact the
                club secretary to register on Spond in order to
                provide your availability.
              </p>

              <p class="h5">
                Please
                <a
                  href="http://ealingtrailfinders.play-cricket.com"
                  target="_blank"
                  >click here</a
                >
                for the player stats and
                <a href="http://www.middlesexccl.com/index.php" target="_blank"
                  >here</a
                >
                for the Middlesex Championship Tables.
              </p>

              <div class="accordion" id="accordion-2018-fixtures-results">
                <div
                  v-for="(team, firstIndex) in teams"
                  v-bind:key="firstIndex"
                  class="card"
                >
                  <div
                    class="card-header"
                    id="headingOne"
                    v-b-toggle="'accordion-' + firstIndex"
                  >
                    <h5 class="mb-0">
                      <button class="btn">{{ team.team }}</button>
                    </h5>
                  </div>

                  <b-collapse
                    :id="'accordion-' + firstIndex"
                    visible
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <div class="row justify-content-around">
                      <div
                        v-for="player in team.players"
                        v-bind:key="player._id"
                        class="col-md-5 no-gutters bg-light mb-4 has-hover-s1"
                      >
                        <div class="row">
                          <!-- image -->
                          <div
                            class="col-6 col-sm-5 m-auto col-md-6 m-md-0 p-3"
                          >
                            <figure class="avatar bg-white">
                              <img
                                v-if="player.image"
                                :src="player.image"
                                alt="profile_image"
                                class
                              />
                              <img
                                v-else
                                src="../../assets/img/anime3.png"
                                alt="profile_image"
                                class
                              />
                            </figure>
                          </div>

                          <!-- text -->
                          <div class="col-6 col-md-6 p-3">
                            <div class="bg-transparent row">
                              <div class="card-body p-0">
                                <ul class="list-unstyled">
                                  <li>
                                    <h5 class="mt-3 m-0">
                                      {{ player.player_name }}
                                    </h5>
                                  </li>
                                  <li>
                                    <h6 class="text-normal">
                                      {{ player.preferred_name }}
                                    </h6>
                                  </li>
                                  <li>
                                    <h5 class="mt-3 m-0">Role:</h5>
                                  </li>
                                  <li>
                                    <h6 class="text-normal">
                                      {{ player.role }}
                                    </h6>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-collapse>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { fetchPlayers } from "@/services/api";

export default {
  data() {
    return {
      teams: [],
    };
  },
  created() {
    this.fetchList();
  },
  methods: {
    fetchList() {
      fetchPlayers().then((response) => {
        let results = [];

        for (let value of response) {
          if (value.selected === "Yes") {
            let teamObj = {};
            teamObj.team = value.team;
            teamObj.players = [];

            if (value.team === "1st XI") teamObj.sort = 1;
            if (value.team === "2nd XI") teamObj.sort = 2;
            if (value.team === "3rd XI") teamObj.sort = 3;
            if (value.team === "1st Sunday XI") teamObj.sort = 4;
            if (value.team === "1st Sunday Friendly XI") teamObj.sort = 5;

            // We check to see if a team has been created
            for (let object of results) {
              if (object.team === value.team) {
                object.players.push(value);
                teamObj = null;
                break;
              }
            }
            // If the team has not been created then we create it in results
            if (teamObj) {
              teamObj.players.push(value);
              results.push(teamObj);
            }
          }
        }
        this.teams = results.sort((a, b) => a.sort - b.sort);
      });
    },
  },
};
</script>
<style></style>
